'use client';

import { useState } from 'react';

import ImageWithFallback from '@/components/ImageWithFallback/ImageWithFallback';
import { AchievementDetailModal } from '@/modules/players/v3/components/shared/achievement-detail-modal/achievement-detail-modal';
import type { Achievement } from '@/modules/players/v3/types/achievements';
import { PICKLEBALL_PLACEHOLDER_IMAGE } from '@/utils/helpers/constants';

interface LatestAchievementCardProps {
  achievement: Achievement;
}

export const LatestAchievementCard = ({ achievement }: LatestAchievementCardProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type='button'
        onClick={() => setOpen(true)}
        className='flex h-full flex-col items-center gap-[3px] p-2 rounded-xl bg-gray-100 hover:bg-gray-200 transition-colors w-full'
      >
        <div className='size-[54px] shrink-0'>
          <ImageWithFallback
            src={achievement.logo ?? undefined}
            fallbackSrc={PICKLEBALL_PLACEHOLDER_IMAGE}
            alt={achievement.achievementName}
            className='size-full object-contain'
          />
        </div>
        <span className='text-xs font-medium text-gray-900 text-center leading-[18px] w-full line-clamp-2'>
          {achievement.achievementName}
        </span>
      </button>

      <AchievementDetailModal
        achievement={achievement}
        open={open}
        onClose={() => setOpen(false)}
        showShare={false}
      />
    </>
  );
};
